import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bottom-navigation" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "nav-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(["bottom-nav", { 'single-item': $setup.accessibleItemsCount === 1 }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navigationWithAccess, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "nav-item",
          key: index
        }, [
          (item.canAccess)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: _normalizeClass(["nav-link", { active: $setup.isActiveRoute(item) }]),
                to: item.link
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require(`../../assets/icons/${item.icon}`),
                    alt: item.title,
                    onError: $setup.handleImageError
                  }, null, 40, _hoisted_2),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 2)
  ]))
}